import {
    useCreateGroup,
    useCreateGroupAddress,
    useCreateGroupCredit,
    useCreateGroupLicense,
} from "@Totum/Groups/State/mutations";
import { TagType } from "@Totum/Main/Components/groups/TagProperties";

/**
 * Orchestrates the operations for the `Search List` component.
 */
const useAssignmentMenuOperations = () => {
    // ** Constants & Variables ** //

    // ** Hooks ** //
    const createGroupCreditMutation = useCreateGroupCredit();
    const createGroupMutation = useCreateGroup();
    const createGroupLicenseMutation = useCreateGroupLicense();
    const createGroupAddressMutation = useCreateGroupAddress();

    // ** Functions ** //

    /**
     * Perform mutations based upon which option is selected from the group assignment menu.
     * @param type
     * @param params
     */
    const addAction = (type: TagType, params: any) => {
        switch (type) {
            case TagType.AddressGroup:
                createGroupAddressMutation.mutateAsync(params);
                break;
            case TagType.LicenseGroup:
                createGroupLicenseMutation.mutateAsync(params);
                break;
            case TagType.CreditGroup:
                createGroupCreditMutation.mutateAsync(params);
                break;
            case TagType.Group:
                createGroupMutation.mutateAsync(params);
                break;
        }
    };

    // ** Exports ** //

    return {
        // data
        // state
        // methods
        addAction,
    };
};

export default useAssignmentMenuOperations;
